module.exports = __webpack_public_path__ + "assets/img/dy@3x.0ec72a9d.png";